import Icon, { IconType } from '@/components/view/atoms/icon/Icon'

const Loading = () => {
  return <Icon type={IconType.LOADING} />
}

export default Loading
